import React from 'react';
import Typography from '@mui/material/Typography';

export default function PrimaryContent(props) {
  return (
    <Typography
      className={props.className || 'primary-content'}
      variant={props.variant || 'h2'}
      sx={{
        fontFamily: 'Lato, sans-serif',
        fontSize: '18px',
        fontWeight: '400',
        lineHeight: '21.6px',
        textAlign: 'left',
        letterSpacing: '0.02em',
        color: 'rgba(84, 84, 84, 1)',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
        ...props.sx,
      }}
    >
      {props.children}
    </Typography>
  );
}